import { render, staticRenderFns } from "./NewsModule.vue?vue&type=template&id=48c70e05&"
import script from "./NewsModule.vue?vue&type=script&lang=js&"
export * from "./NewsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports